import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PipeProvider from 'Services/Providers/PipeProvider';
import { VertButton, VertLoading, VertTypography } from '@vertem-core/vertice-ds';
import { balanceUser } from '../BalanceUser';
import { pointsMask } from 'Utils/commons/points';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { BALANCE_SHOW_HIDE } from 'redux/Reducers/Balance/BalanceReducer';

const handleBalance = ({ value, label, isHiden }) => {
    if(isHiden) return `***** ${label}`

    return `${value} ${label}`
}

const HeaderPoints = () => {
    const Balance = useSelector(({ Balance: data }) => data);
    const Catalog = useSelector(({ Catalog: data }) => data);
    const { pointsValue, hidePoints } = Balance;
    const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;

    const dispatch = useDispatch();
    
    const balanceLabel = handleBalance({...pointsMask(pointsValue, decimalPlaces, pointsName), isHiden: hidePoints})

    return (
        <PipeProvider
            apiSymbols={['FETCH_CATALOG', 'LOAD_BALANCE']}
            loadingComponent={<div className="header-points"><VertLoading type="spin" size="small" color="#25CC6E" /></div>}
        >
            <div className="header-points">
                <VertTypography.Paragraph aria-label={ balanceUser(balanceLabel) } >
                    {balanceUser(balanceLabel) }

                    <VertButton
                        type="link"
                        className='vert-button'
                        shape={'default'}
                        size={'small'}
                        onClick={() => {
                            dispatch({type: BALANCE_SHOW_HIDE, payload: {hidePoints: !hidePoints}})
                        }}
                        icon={!hidePoints ? <LuEye size={18} className='icon-lueye' display={'block'}/> : <LuEyeOff size={18} className='icon-lueye' display={'block'}/>}
                    />
                    
                </VertTypography.Paragraph>
            </div> 
        </PipeProvider>
    );
};


export default HeaderPoints;
